import * as React from "react"
import ChartLines from "../../atoms/chart/chart-lines"
import chartColors from "../../atoms/chart/chart-colors"
import Format from "../../atoms/format"

/**
 * Internal dependencies.
 */
import "./_table.scss"

const TableChart = props => {
  const tableData = props.tableData
  const tableType = props.tableType
  const toggleType = props.toggleType
  const showLines = props.showLines ?? []
  const skip = props?.skip ?? 0
  const skipYears = props?.skipYears ?? []
  const noBackground = props?.noBackground ?? true
  const displayDanger = props?.displayDanger
  const asteriskLabel = props?.asteriskLabel
	const chartNotesBefore = props?.chartNotesBefore
	const chartNotesAfter = props?.chartNotesAfter

  // set atom class
  const atomClassName =
    "table w-100 table-chart" +
    " is-type-" +
    tableType +
    " is-toggle-type-" +
    toggleType
  var atomClass =
    props.className != undefined
      ? atomClassName + " " + props.className
      : atomClassName

  const handleToggleLine = event => {
    // console.log(event.currentTarget.closest('tbody').querySelectorAll('tr'));
    if (toggleType == "radio") {
      const allTrs = event.currentTarget.closest("tbody").querySelectorAll("tr")
      if (allTrs) {
        allTrs.forEach(tr => {
          tr.classList.remove("active")
        })
      }
      // event.currentTarget.closest('tbody').querySelectorAll('tr').classList.remove('active');
    }
    event.currentTarget.closest("tr").classList.toggle("active")
  }

  return (
    <div className="d-flex flex-column gap-2 table-content-wrap">
      {tableData.notes && (
        <div className={`fs-13 mb-0 ${"" ?? tableData.notes.align}`}>
          {tableData.notes.content}
        </div>
      )}
      <div className="row justify-content-between table-chart-wrap gx-0">
        <div className="col-md-4 flex-column d-flex mb-5 mb-md-0">
          <table className={atomClass}>
            {tableData.rows && (
              <tbody>
                {tableData.rows?.map((dataRow, dataRowId) => {
                  let rowClass =
                    tableType == "line-chart" ? "data-line-src" : ""

                  let isRowActive = false

                  if (
                    (toggleType == "radio" && dataRowId == 0) ||
                    toggleType == "checkbox"
                  ) {
                    isRowActive = true
                  }

                  rowClass = isRowActive ? rowClass + " active" : rowClass

                  return (
                    dataRow && (
                      <tr
                        key={"table-row-" + dataRowId}
                        className={rowClass}
                        data-line-src
                      >
                        <td style={{ "--linecolor": chartColors[dataRowId] }}>
                          {toggleType && (
                            <button
                              className="line-toggler"
                              onClick={handleToggleLine}
                            />
                          )}
                        </td>
                        <td>
                          {dataRow.rowHeader && (
                            <div className="data-header">
                              {dataRow.rowHeader.val}
                            </div>
                          )}
                          <div className="data-cols">
                            {dataRow.cols.map((dataCol, dataColIdx) => {
                              return (
                                !skipYears?.includes(
                                  tableData.headers[0].cols[dataColIdx + 1]
                                ) && (
                                  <div
                                    key={"dataCol-" + dataColIdx}
                                    className="data-col"
                                  >
                                    <span className="data-label">
                                      {
                                        tableData.headers[0].cols[
                                          dataColIdx + 1
                                        ]
                                      }
                                    </span>
                                    <span className="data-value">
                                      <Format
                                        dataVal={dataCol.val}
                                        dataType={dataCol.format}
                                      />
                                      {displayDanger &&
                                        tableData.headers[0].cols[
                                          dataColIdx + 1
                                        ] === 2022 && (
                                          <span className="text-danger">*</span>
                                        )}
                                    </span>
                                  </div>
                                )
                              )
                            })}
                          </div>
                        </td>
                      </tr>
                    )
                  )
                })}
              </tbody>
            )}
          </table>
          {displayDanger && (
            <div className="fs-14 text-gray">
              * { asteriskLabel }
            </div>
          )}
        </div>
        <div className="col-md-7">
          <ChartLines
            tData={tableData}
            className="w-100"
            toggleType={toggleType}
						showLines={showLines}
						skip={skip}
            noBackground={noBackground}
						asteriskLabel={asteriskLabel}
          />
					{
						(chartNotesBefore || chartNotesAfter) && (
							<div className="d-sm-block d-md-flex chart-notes-wrap">
								<span className="d-flex align-items-center align-items-md-start pb-2">{chartNotesBefore}</span>
								<span className="d-flex align-items-center align-items-md-start pb-2">{chartNotesAfter}</span>
							</div>
						)
					}
        </div>
      </div>
    </div>
  )
}

export default TableChart
